import { render } from "./LoadingCharts.vue?vue&type=template&id=4405306a&scoped=true"
import script from "./LoadingCharts.vue?vue&type=script&lang=js"
export * from "./LoadingCharts.vue?vue&type=script&lang=js"

import "./LoadingCharts.vue?vue&type=style&index=0&id=4405306a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4405306a"]])

export default __exports__